module.exports = __webpack_public_path__ + "models/target.0df946da.gltf";